import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {addEcritures, loadEcritures} from "../../store/actions/ecritureAction";
import { loadComptes } from "../../store/actions/compteAction";
import { Spin } from "antd";
import FormAcompte from "../../components/FormAcompte";

export default function OwnerPayment({onActive}) {
  const dispatch = useDispatch();

  const {
    //utilisateur,
    ecritures,
    comptes,
  } = useSelector(
    (state) => ({
      //utilisateur: state.utilisateur?.data,
      ecritures: state.ecritures,
      comptes: state.comptes,
    }),
    shallowEqual
  );

  /*const spinning = useMemo(
    () => Boolean(!ecritures?.loaded || !comptes?.loaded),
    [ecritures, comptes]
  );*/

  useEffect(() => {
    // Si ces actions sont des thunks idempotents, pas de souci à les rappeler.
    dispatch(loadEcritures());
    dispatch(loadComptes());
  }, [dispatch]);

  // Insert manuel du tableau d'écritures
  const handleAddEcriture = (jsonData) => {
    dispatch(addEcritures(jsonData));
  };

  return (
    <>
      <Spin fullscreen size="large" tip="Chargement en cours..." spinning={Boolean(!ecritures.loaded || !comptes?.loaded)} />
      <FormAcompte
        onActive={onActive}
        comptes={comptes?.data}
        addEcriture={handleAddEcriture}
      />
    </>
  );
}
